import * as tslib_1 from "tslib";
import { all, put, select } from 'redux-saga/effects';
import { normalize } from '../../redux/normalizr';
import groupBy from 'lodash/groupBy';
import { galleryFolderSchema, collectionFolderSchema, } from '../../redux/normalizr/schemas/folder';
import { selectors, withOffset } from '../../Stream';
import { GALLECTIONS_PER_FETCH, MEDIA_POPUP_GALLECTION_STREAM_GROUP, } from '../constants';
import { getGallectionStreamId } from '../helpers';
import { getMode, getCurrentMediaSource } from '../selectors';
import { MediaPopupMode, MediaSourceType } from '../types';
import { flagEnabled } from '../../redux/flags';
import { FEATURE_SUBFOLDERS } from '../../features';
export function getStreamInitAction(mediaSource, folderId, gallectionFolders) {
    var streamId = getGallectionStreamId(mediaSource, folderId);
    var normalizedGallections = normalize(gallectionFolders || [], [
        mediaSource === MediaSourceType.GALLERY
            ? galleryFolderSchema
            : collectionFolderSchema,
    ]);
    return withOffset.actions.initialize({
        streamId: streamId,
        groupId: MEDIA_POPUP_GALLECTION_STREAM_GROUP,
        streamParams: {
            mediaSource: mediaSource,
        },
        itemsPerFetch: GALLECTIONS_PER_FETCH,
        hasMore: !gallectionFolders,
        items: normalizedGallections && normalizedGallections.result,
        entities: normalizedGallections && normalizedGallections.entities,
    });
}
function handleInitGallectionStream(action) {
    var mediaSource, gallectionFolders, streamId, mode, withSubfolders, isStreamInitialized, cacheStreams, foldersByParentId_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _a.sent();
                if (!mediaSource) {
                    return [2 /*return*/];
                }
                gallectionFolders = action.payload && action.payload.gallectionFolders;
                streamId = getGallectionStreamId(mediaSource);
                return [4 /*yield*/, select(getMode)];
            case 2:
                mode = _a.sent();
                return [4 /*yield*/, select(function (state) {
                        return flagEnabled(state, FEATURE_SUBFOLDERS);
                    })];
            case 3:
                withSubfolders = _a.sent();
                return [4 /*yield*/, select(selectors.isInitialized, streamId)];
            case 4:
                isStreamInitialized = _a.sent();
                cacheStreams = true;
                if (mode === MediaPopupMode.MANAGER) {
                    cacheStreams = false;
                }
                if (isStreamInitialized && cacheStreams) {
                    return [2 /*return*/];
                }
                if (!withSubfolders) return [3 /*break*/, 9];
                if (!(gallectionFolders && gallectionFolders.length)) return [3 /*break*/, 6];
                foldersByParentId_1 = groupBy(gallectionFolders || [], 'parentId');
                return [4 /*yield*/, all(Object.keys(foldersByParentId_1)
                        .filter(function (parentId) { return +parentId; })
                        .map(function (parentId) {
                        var folders = foldersByParentId_1[parentId];
                        return put(getStreamInitAction(mediaSource, +parentId, folders));
                    }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(getStreamInitAction(mediaSource, null, []))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, put(getStreamInitAction(mediaSource, null, gallectionFolders))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11:
                if (!!gallectionFolders) return [3 /*break*/, 13];
                return [4 /*yield*/, put(withOffset.actions.fetch(streamId))];
            case 12:
                _a.sent();
                _a.label = 13;
            case 13: return [2 /*return*/];
        }
    });
}
export default handleInitGallectionStream;
//# sourceMappingURL=initGallectionStream.js.map